import { render, staticRenderFns } from "./rejectedReceipts.vue?vue&type=template&id=0f2955ec&scoped=true"
import script from "./rejectedReceipts.vue?vue&type=script&lang=js"
export * from "./rejectedReceipts.vue?vue&type=script&lang=js"
import style0 from "./rejectedReceipts.vue?vue&type=style&index=0&id=0f2955ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2955ec",
  null
  
)

export default component.exports